
export enum AppErrorCode {
  //TODO add error codes
  UNKNOWN = 0,

  // Basket
  BASKET_SMS_NOTIFICATIONS_FAILED = 1,

  // Menu
  MENU_DETAIL_NOTIFICATION_SETUP_FAILED = 132,
  ADD_ITEM_TO_IHGROUP_BASKET_FAILED = 133,
  IHGROUP_ORDER_DIRECTLY_STATUS_NOT_OKAY = 134,
  IHGROUP_ORDER_DIRECTLY_TECHNICAL_ERROR = 135,
}
